import { t } from 'i18next';
import * as yup from 'yup';

import { LENGTH_S, LENGTH_XXL } from '../constants';
import { emailPattern, entityOrContext } from '../patterns';

// Email sender form schema for integrations/email AgentInfo
export const emailSenderSchema = yup.object().shape({
  from_email: yup
    .string()
    .required(() => t('email.errors.sender_email_required'))
    .matches(emailPattern, { message: () => t('email.errors.sender_email_invalid') })
    .max(LENGTH_S, () => t('email.errors.sender_email_max', { 0: LENGTH_S }))
    .defined(),
  from_name: yup
    .string()
    .required(() => t('email.errors.sender_name_required'))
    .max(LENGTH_S, () => t('email.errors.sender_name_max', { 0: LENGTH_S }))
    .defined(),
});

export const emailToolkitRules = {
  from: { required: true, pattern: emailPattern, maxLength: LENGTH_S },
  recipient: {
    validate: {
      maxLength: (value) => {
        if (typeof value === 'string') {
          return value.length <= LENGTH_S;
        }
        return value?.label?.length <= LENGTH_S;
      },
      pattern: (value) => {
        if (value === '') {
          return true;
        }
        if (typeof value === 'string') {
          return emailPattern.test(value) || entityOrContext.test(value);
        }

        return emailPattern.test(value?.label) || entityOrContext.test(value?.label);
      },
    },
  },
  subject: { required: true, maxLength: LENGTH_S },
  body: { maxLength: LENGTH_XXL },
};
